import { initialState } from "./index";
/*
* Update field reducer handles
* 1. update the field's info
* 2. reset the state of save
* 3. update the state of application submittable
* */
const resetSave = () => ({
  save: { ...initialState.save }
});

const updateSubmit = (prevIsActive, error) => ({
  submit: {
    ...initialState.submit,
    isActive: prevIsActive && !error
  }
});

export default (state, action) => {
  const {
    payload: { name, value, error }
  } = action;
  return {
    ...state,
    fields: {
      ...state.fields,
      [name]: {
        ...state.fields[name],
        value,
        error
      }
    },
    ...resetSave(),
    ...updateSubmit(state.submit.isActive, error)
  };
};
